import React from 'react';
import styled from 'styled-components';
import { COLORS, MQS, SPACINGS } from '../app/common/constants/styles';
import { TranslationHelpers } from '../i18n/translationHelpers';

const bannerWidthOffset = `${SPACINGS.base * 5}px`;
const bannerMargin = `${SPACINGS.base * 2}px ${SPACINGS.base * 4}px ${SPACINGS.base * 2}px ${
    SPACINGS.base
}px`;
const bannerPadding = `${SPACINGS.base * 1.5}px ${SPACINGS.base * 2}px ${SPACINGS.base * 2}px`;
const bannerMarginMobile = `${SPACINGS.base * 1.5}px 0`;
const titleMarginBottom = `0 0 ${SPACINGS.base * 1.5}px 0`;
const textMargin = `${SPACINGS.base}px 0`;

const BannerWrapper = styled.div`
    width: calc(100% - ${bannerWidthOffset});
    margin: ${bannerMargin};
    padding: ${bannerPadding};
    background-color: ${COLORS.notificationBannerBackground};
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0 rgba(4, 114, 5, 0.1);
    position: relative;
    box-sizing: border-box;
    @media (max-width: ${MQS.mq2Max}) {
        width: 100%;
        margin: ${bannerMarginMobile};
    }
`;

const NotificationTitle = styled.p`
    font-size: 1rem;
    font-weight: 700;
    color: ${COLORS.notificationBannerText};
    margin: ${titleMarginBottom};
    line-height: 1.5;
`;

const NotificationText = styled.p`
    font-size: 1rem;
    color: ${COLORS.notificationBannerText};
    margin: ${textMargin};
    line-height: 1.5;
    @media (max-width: ${MQS.mq2Max}) {
        font-size: 0.875rem;
    }
`;

export const TopPageNotificationBanner: React.FC = () => {
    const paymentMethod = TranslationHelpers.getFormattedMessage('profile.payment');

    return (
        <BannerWrapper>
            <NotificationTitle>
                {TranslationHelpers.getFormattedMessage('notification.cardholder_name.title')}
            </NotificationTitle>
            <NotificationText>
                {TranslationHelpers.getFormattedMessage('notification.cardholder_name.line1', {
                    paymentMethod,
                })}
            </NotificationText>
            <NotificationText>
                {TranslationHelpers.getFormattedMessage('notification.cardholder_name.line2')}
            </NotificationText>
            <NotificationText>
                {TranslationHelpers.getFormattedMessage('notification.cardholder_name.line3', {
                    paymentMethod,
                })}
            </NotificationText>
        </BannerWrapper>
    );
};
